"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocale = useLocale;
exports.LocaleProvider = exports.LocaleContext = exports.LOCALE_PERSISTED_PROP = exports.LOCALE_PERSISTED_KEY = void 0;

var React = _interopRequireWildcard(require("react"));

var _i18n = require("../../i18n");

var _storage = require("../../utils/storage");

const LOCALE_PERSISTED_KEY = 'Localization';
exports.LOCALE_PERSISTED_KEY = LOCALE_PERSISTED_KEY;
const LOCALE_PERSISTED_PROP = 'locale';
exports.LOCALE_PERSISTED_PROP = LOCALE_PERSISTED_PROP;
const LocaleContext = /*#__PURE__*/React.createContext({
  locale: _i18n.defaultLocale,
  setLocale: () => undefined
});
exports.LocaleContext = LocaleContext;

function useLocale() {
  const {
    locale,
    setLocale
  } = React.useContext(LocaleContext);
  return {
    locale,
    setLocale
  };
}

const LocaleProvider = ({
  children
}) => {
  const [locale, setLocale] = React.useState((0, _storage.getPersisted)({
    key: LOCALE_PERSISTED_KEY,
    prop: LOCALE_PERSISTED_PROP,
    useLocalStorage: true
  }, _i18n.defaultLocale));
  React.useEffect(() => {
    (0, _storage.setPersisted)({
      key: LOCALE_PERSISTED_KEY,
      prop: LOCALE_PERSISTED_PROP,
      useLocalStorage: true
    }, locale);
  }, [locale]);
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: {
      locale,
      setLocale
    }
  }, children);
};

exports.LocaleProvider = LocaleProvider;